import React, { useState, useEffect } from "react";
import TableViewSearch from "../../../CustomComponent/TableViewSearch";
import TableView from "../../../CustomComponent/TableView";
import useStyles from "../../../../styles";
import { Button, FormControlLabel, FormLabel, MenuItem, Paper, Popover, Radio, RadioGroup, Select, Tooltip, withStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import ArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { ReactComponent as ActiveIcon } from "../../../images/commonicon/activeicon.svg";
import { ReactComponent as InactiveIcon } from "../../../images/commonicon/inactiveicon.svg";
import { Link, useNavigate } from "react-router-dom";

import { decryptData } from "../../../../crypto";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

function ViewHallTicket() {
  const classes = useStyles();
  const style = [
    {
      height: 'maxh67',
      style: "viewtable",
      checkboxselection: "true",
    },
  ];
  const [anchorEl, setAnchorEl] = useState(null);
  const popoveropen = Boolean(anchorEl);
  const id = popoveropen ? "simple-popover" : undefined;
  const [selectedRowId, setSelectedRowId] = useState();

  const [searchQuery, setSearchQuery] = useState("");
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const [hallTicket, setHallTicket] = useState([]);
  let [rowsIds, setRowsIds] = useState([]);
  const navigate = useNavigate();

  const handleClick = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(rowId);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const LightTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }))(Tooltip);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/registration_candidate/centers/allocations`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      console.log("response center hallTicket", response)
      setHallTicket(response?.data?.candidate_center_allocations);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
      fetchData();
  }, []);


  // Function to delete a book
  const deleteDataOfRow = async (rowId) => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));
      const response = await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/registration_allocated/centers/${rowId}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );

      fetchData();
      handleClose();
      toast.success("Allocation center deleted successfully");
      const updateddatatata = hallTicket.filter((data) => data.id !== rowId);
      setHallTicket(updateddatatata);
    } catch (error) {
      toast.error("Allocation center is not deleted");
      console.error("Error deleting data: ", error);
    }
  };

  const rows = hallTicket.map((d) => ({
    id: d.id ? d.id : "N/A",
    full_name: d?.candidate?.full_name ? d?.candidate?.full_name : "N/A",
    dob: d?.candidate?.dob ? d?.candidate?.dob : "N/A",
    email: d?.candidate?.email ? d?.candidate?.email : "N/A",
    phone: d?.candidate?.phone ? d?.candidate?.phone : "N/A",
    gender: d?.candidate?.gender ? d?.candidate?.gender : "N/A",
    category_type: d?.candidate?.category_type ? d?.candidate?.category_type : "N/A",
    marital_status: d?.candidate?.marital_status ? d?.candidate?.marital_status : "N/A",
    active_status: d.active_status ? d.active_status : "N/A",
  }));

  const filteredRows = rows
    .filter((d) => {
      const isSearchMatch = d?.full_name
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) || d?.full_name
          .toLowerCase()
          // .includes(searchQuery.toLowerCase()) || d.batch_name
          // .toLowerCase()
          .includes(searchQuery.toLowerCase())

      return isSearchMatch;
    })
    .map((row, index) => ({
      ...row,
      srno: index + 1,
    }));


  const columns = [
    {
      field: "srno",
      headerName: "#",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 100,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },

    {
      field: "full_name",
      headerName: "Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      // flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "dob",
      headerName: "Date of Birth",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      // flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "email",
      headerName: "Email",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      // flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "phone",
      headerName: "Mobile Number",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      // flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "gender",
      headerName: "Gender",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      // flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "category_type",
      headerName: "Category",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      // flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "marital_status",
      headerName: "Marital Status",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      // flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },

    // {
    //   field: "active_status",
    //   headerName: "Action",
    //   headerClassName: "super-app-theme--header",
    //   headerAlign: "center",
    //   sortable: false,
    //   disableColumnMenu: true,
    //   width: 200,
    //   autoPageSize: false,
    //   renderCell: (cellValues) => {
    //     const status = cellValues.row.active_status;

    //     return (
    //       <div
    //         className={`${classes.dflex} ${classes.w100} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
    //       >
    //         <IconButton
    //           className={`${classes.w15}`}
    //           aria-describedby={id}
    //           onClick={(event) => {
    //             handleClick(event, cellValues.row.id);
    //           }}
    //         >
    //           <ArrowLeftIcon fontSize="small" />
    //         </IconButton>
    //         <Typography
    //           className={`${classes.dflex} ${classes.alignitemscenter} ${classes.texttransformcapitalize}`}
    //           variant="h6"
    //         >
    //           {status === "approved" ? (
    //             <ActiveIcon className={`${classes.mr0_5}`} />
    //           ) : (
    //             <InactiveIcon fontSize="small" className={`${classes.mr0_5}`} />
    //           )}

    //           {cellValues.row.active_status}
    //         </Typography>
    //         <Popover
    //           id={id}
    //           open={popoveropen && selectedRowId === cellValues.row.id}
    //           anchorEl={anchorEl}
    //           onClose={handleClose}
    //           anchorOrigin={{
    //             vertical: "center",
    //             horizontal: "left",
    //           }}
    //           transformOrigin={{
    //             vertical: "center",
    //             horizontal: "right",
    //           }}
    //         >
    //           <Paper>
    //             <IconButton
    //               onClick={(event) => {
    //                 handleStatus(
    //                   cellValues.row.id,
    //                   cellValues.row.active_status
    //                 );
    //                 handleClose();
    //               }}
    //             >
    //               <LightTooltip title="Inactive">
    //                 <VisibilityOffOutlinedIcon />
    //               </LightTooltip>
    //             </IconButton>
    //             <IconButton
    //               onClick={() => {
    //                 handleButtonClick("editCenter", cellValues.row.id);
    //                 handleClose();
    //               }}
    //             >
    //               <LightTooltip title="Edit">
    //                 <EditOutlinedIcon />
    //               </LightTooltip>
    //             </IconButton>
    //             <IconButton>
    //               <LightTooltip title="Delete">
    //                 <DeleteIcon
    //                   onClick={() => {
    //                     deleteDataOfRow(cellValues.row.id)
    //                     handleClose();
    //                   }}
    //                 />
    //               </LightTooltip>
    //             </IconButton>
    //           </Paper>
    //         </Popover>
    //       </div>
    //     );
    //   },
    // },
  ];

  const Heading = [
    {
      id: 1,
      // inputlable: "Subject / Course",
      inputplaceholder: "Search by center",
      // export: "yes",
    },
  ];

  const menuProps = {
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left",
    },
    disablePortal: true,
  };

  const handleCheckboxClick = (selectedIDs) => {
    setRowsIds(selectedIDs);
  };

  const generateHallTicket = () => {
    if(rowsIds.length === 0){
      toast.warn("Please Select atleast one ID!");
      return;
    }
    const data = {
      generate_hallticket: {
        ids: rowsIds,
      },
    };

    axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/v1/b2b/registration_candidate/generate/hallticket/all`, data, {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        const res = response.data;

        if (res.success) {
          toast.success(res.message || "Hall ticket generated");
          // navigate("/admin/allocatedcenter");
         window.location.reload();
        } else {
          toast.error(res.message || "Something went wrong");
        }
      })
      .catch((error) => {
        toast.error(
          error.response?.data?.message || "Something went wrong. Please try again."
        );
      });
  };

  console.log("hallTicket",hallTicket)
  return (
    <>
      <ToastContainer />
      <div
        className={`${classes.bgwhite} ${classes.alignitemsend} ${classes.justifyspacebetween} ${classes.inputpadding} ${classes.inputborder} ${classes.boxshadow3} ${classes.borderradius6px}  ${classes.mt1}`}
      >
        <TableView columns={columns} rows={filteredRows} Heading={style} onCheckboxClick={handleCheckboxClick} />
         <div
                className={`${classes.w100} ${classes.dflex} ${classes.justifyflexend}`}
              >
                <Button
                  variant="contained"
                  color="primary"
                  className={`${classes.bluebtn} ${classes.my0_5}`}
                  onClick={generateHallTicket}
                >
                  Submit
                </Button>
              </div>
      </div>
    </>
  );
}
export default ViewHallTicket;
